import { Navigate } from "react-router-dom";
import { ContactDetailsBlockContent } from "@tellescope/contact-details";
import { PageHeader } from "../../components/PageHeader";
import { useContactDetailsTakeoverPage } from "./useContactDetailsTakeoverPage";
import { useReopenSidebarAction } from "./useReopenSidebarAction";

export const ContactDetailsTakeoverPage = () => {
  const {
    block,
    resolvedBlockIndex,
    blockId,
    viewId,
    enduserId,
    isUnresolvable,
    isFeatureEnabled,
    canUpdateObservations,
    onClose,
    onOpenTicket,
    onOpenEvent,
    onChangeEnduser,
  } = useContactDetailsTakeoverPage();

  const reopenAction = useReopenSidebarAction(enduserId ?? "");

  if (isUnresolvable) return <Navigate replace to="/contacts" />;
  if (!block || !enduserId || !viewId) return null;

  return (
    <>
      <PageHeader hideTitle onClose={onClose} trailingActions={reopenAction ? [reopenAction] : []} />
      <section className="p-4 flex flex-col flex-1 min-h-0">
        <ContactDetailsBlockContent
          className="grow flex flex-col min-h-0"
          blockLayout="fill"
          viewId={viewId}
          isFeatureEnabled={isFeatureEnabled}
          canUpdateObservations={canUpdateObservations}
          block={block}
          blockId={blockId}
          blockIndex={resolvedBlockIndex}
          enduserId={enduserId}
          editMode
          alwaysShowButtons
          onOpenTicket={onOpenTicket}
          onOpenEvent={onOpenEvent}
          onChangeEnduser={onChangeEnduser}
        />
      </section>
    </>
  );
};
